module.exports = __webpack_public_path__ + "media/images/lb/459-51bc0cd4df5a91c8d829eaba0bbefb78.svg";